// Services
import AdministracaoService from "./AdministracaoService";

// Mixin padrão para a tabela
import TabelaMixin from "@/shared/mixin/TabelaMixin";

// Services de unimeds
import UnimedService from "@/shared/services/UnimedService";

export default {
  name: "administracao-unimeds",
  mixins: [AdministracaoService, TabelaMixin, UnimedService],
  data() {
    return {
      limparUnimed: false,
      listaAnalistas: [],
      campoPesquisa: {
        descricao: "",
        chave: ""
      },
      listaStatus: [],
      listaUnimedOrigem: [],
      listaTipoAtuacao: [],
      objetoFiltroLocal: {},
      cabecalho: [
        {
          texto: "Código",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "70px"
          },
          campoOrdenacao: "cdUnimed"
        },
        {
          texto: "Nome",
          estiloColuna: {
            "min-width": "250px"
          }
        },
        {
          texto: "Tipo de Atuação",
          estiloColuna: {
            "min-width": "130px"
          }
        },
        {
          texto: "1º Dia de envio",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "130px"
          },
          campoOrdenacao: "diaEnvio1"
        },
        {
          texto: "2º Dia de envio",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "130px"
          },
          campoOrdenacao: "diaEnvio2"
        },
        {
          texto: "Analista responsável",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "200px"
          },
          campoOrdenacao: "analista.nome"
        }
      ]
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    /**
     * Método inicial da página
     */
    init() {
      this.loadingTabela = true;
      this.iniciarAnalistasResponsaveis().finally(() => {
        this.iniciarUnimedsFiltro().finally(() => {
          this.inicializarTipoAtuacao().finally(() => {
            this.objetoTabela.ordenacao = "diaEnvio1";

            this.iniciarTabela();
          });
        });
      });
    },
    iniciarAnalistasResponsaveis() {
      return new Promise(resolve => {
        this.getAnalistasUnimed().then(res => {
          this.listaAnalistas = res.data;
          resolve();
        });
      });
    },
    /**
     * Método que faz a chamada na service para recuperar as unimeds utilizadas no filtro
     * @return { Promise<any> }
     */
    iniciarUnimedsFiltro() {
      return new Promise(resolve => {
        this.getAllUnimeds()
          .then(res => {
            this.listaUnimedOrigem = res.data;
          })
          .finally(() => {
            resolve();
          });
      });
    },
    inicializarTipoAtuacao() {
      return new Promise((resolve, reject) => {
        this.getTipoAtucao()
          .then(res => {
            this.listaTipoAtuacao = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    /**
     * Método que faz a chamada na service para recuperar as linhas da tabela e outras informações adicionais
     */
    iniciarTabela() {
      this.loadingTabela = true;
      let tempObjetoTabela = this.objetoTabelaAtual();

      if (this.campoPesquisa.chave) {
        tempObjetoTabela.unimedOrigem = this.campoPesquisa.chave;
      }

      this.getTabelaAdministracao(tempObjetoTabela)
        .then(res => {
          this.configurarTabela(res.data, rows => {
            this.montarTabela(rows);
          });
        })
        .finally(() => {
          this.loadingTabela = false;
          this.iniciado = true;
        });
    },
    /**
     * Método para montar a tabela
     *  @param {Array} rows - linhas da tabela
     */
    montarTabela(rows) {
      this.rows = [];
      rows.forEach(e => {
        const {
          codigo,
          nome,
          tipoAtuacao,
          primeiroDia,
          segundoDia,
          analistaResponsavel
        } = e;
        this.rows.push({
          codigo: {
            textoEstilo: this.zeroEsquerda(codigo),
            estiloTexto: {
              width: "36px",
              background: "#00995d",
              "border-radius": "8px",
              position: "relative",
              padding: "4px",
              "text-align": "center",
              color: "white",
              "font-family": "Unimed Slab",
              "font-weight": "bold"
            }
          },
          nome: {
            texto: nome || " - ",
            qtdMaxCaracteres: 30,
            whiteSpaceNoWrap: false,
            larguraMaxima: 900,
            tooltipLocalizacao: "top"
          },
          tipoAtuacao,
          primeiroDia: primeiroDia ? this.zeroEsquerda(primeiroDia, 2) : " - ",
          segundoDia: segundoDia ? this.zeroEsquerda(segundoDia, 2) : " - ",
          analistaResponsavel,
          naoMostrar: {
            naoAparece: true,
            codigoUnimed: codigo
          }
        });
      });
      this.salvarFiltro();
    },
    /**
     * Limpa o objeto da pesquisa
     */
    limparPesquisa() {
      this.campoPesquisa = {
        descricao: "",
        chave: ""
      };
    },
    /**
     * Método pra fazer a chamada para unimedOrigem vazia, logo após limpar o campo de pesquisa
     */
    limparCampoPesquisa() {
      this.limparPesquisa();
      this.filtrar({ unimedOrigem: "" });
      this.limparUnimed = true;
    },
    /**
     * Método para selecionar o código da unimed
     * @param {Number, String} index - o index da listagem que está no autocomplete
     */
    selecionarPesquisa(index) {
      if ([undefined, null, "", -1].includes(index)) return;

      this.limparUnimed = true;
      this.$set(this.campoPesquisa, "chave", this.listaUnimedOrigem[index].id);
      this.filtrar({ unimedOrigem: "" });
    },

    /**
     * Método que é chamado logo após feito o clique em uma das linhas
     * @param {Number} index - linha que foi feito o clique
     */
    clickLinha(index) {
      const { codigoUnimed } = this.rows[index].naoMostrar;
      if ([null, undefined, ""].includes(codigoUnimed)) return;
      this.$router.push("/administracao/unimeds/" + codigoUnimed);
    }
  }
};
